// Status code for client sharing
export const TABLEAU_SHARING_IN_PROGRESS_STATUS = 1;
export const TABLEAU_SHARING_SUCCESS_STATUS = 2;
export const TABLEAU_SHARING_FAILED_STATUS = 3;

export const getTabNameBySheetUrl = (sheetUrl) => {
  const sheetUrlTemp = sheetUrl.split('/');
  return sheetUrlTemp[sheetUrlTemp.length - 1];
};

/**
 * It converts the embedUrl with all tabs to embedUrl with single tab
 * @param {*} embedUrl
 * @param {*} sheetUrl
 * @returns
 */
export const convertToSingleTabEmbedUrl = (embedUrl, tabName) => {
  let url = embedUrl.split('/');
  url[url.length - 1] = tabName;
  url = url.join('/');
  return url;
};

export const resizeTableau = async (
  vizRef,
  tableauContainerRef,
  dimensionsRef,
  fixedHeight
) => {
  try {
    if (
      vizRef.current &&
      tableauContainerRef.current &&
      dimensionsRef.current
    ) {
      const workbook = vizRef.current.getWorkbook();
      if (workbook) {
        if (fixedHeight) {
          fixedHeight = `${fixedHeight}px`;
        }

        // set the tableau width as the current width of the div
        dimensionsRef.current = {
          height: `${tableauContainerRef.current.offsetHeight}px`,
          width: `${tableauContainerRef.current.offsetWidth}px`,
        };
        tableauContainerRef.current.style.overflow = 'hidden';
        const sheet = workbook.getActiveSheet();
        sheet
          .changeSizeAsync({
            behavior: 'EXACTLY',
            maxSize: {
              height: fixedHeight || dimensionsRef.current.height,
              width: dimensionsRef.current.width,
            },
          })
          .then(
            vizRef.current.setFrameSize(
              dimensionsRef.current.width,
              fixedHeight || dimensionsRef.current.height
            )
          );
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`Error on scaling Tableau File:  ${error}`);
  }
};

/**
 * It removes white spaces and special characters from tabName to be used on the embed url
 * . should not be removed but replaced by _ instead
 * @param {*} tabName
 * @returns
 */
export const getTabNameForEmbedUrl = (tabName) => {
  let tabNameForEmbedUrl = tabName.replace(/[^0-9a-z.]/gi, '');
  tabNameForEmbedUrl = tabNameForEmbedUrl.replace('.', '_');
  return tabNameForEmbedUrl;
};

/**
 * Activate full screen mode for tableau
 * @param {*} div
 * @returns
 */
export const openFullScreen = (div) => {
  if (div) {
    if (div.requestFullscreen) {
      div.requestFullscreen();
      return;
    }
    if (div.webkitRequestFullscreen) {
      /* Safari */
      div.webkitRequestFullscreen();
      return;
    }
    if (div.msRequestFullscreen) {
      /* IE11 */
      div.msRequestFullscreen();
    }
  }
};
